import { render, staticRenderFns } from "./SaldoDisponivel.vue?vue&type=template&id=9926e08e"
import script from "./SaldoDisponivel.vue?vue&type=script&lang=js"
export * from "./SaldoDisponivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports